/* global CriteriaHelper */
import * as React from 'react';

// Components
import PlainRenderInputElement from './PlainRenderInputElement';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStorePredicate';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

export const DataInputConcept = ({ id, plainrender = true, ...props }) => {
    const part = useCriteriaStorePredicate(id);
    const conceptsArr = CriteriaHelper.partTypes.dataInputConcept.displayValues(part) ?? [];
    const renderValue = conceptsArr.length
        ? conceptsArr.map((concept, index) => {
              return (
                  <div key={index}>
                      {concept}
                      {index < conceptsArr.length - 1 ? '& ' : ''}
                  </div>
              );
          })
        : undefined;

    return (
        <PlainRenderInputElement value={renderValue} placeholderPartial={'concepts'} overridable={part?.overridable} />
    );
};

export default DataInputConcept;

DataInputConcept.propTypes = {
    ...ruleEditorViewPartCommonProps
};
